import jtMark from '../../assets/jt-mark.png';

/** The 2026 JobTetris mark's width to height (from the source artwork, 3245 x 2969). */
const ASPECT = 3245 / 2969;

/**
 * The JobTetris mark (JT1-1909). `size` is its height in pixels. Pass `decorative` when the word
 * "JobTetris" is right beside it, so screen readers don't hear the name twice.
 */
export function JobTetrisMark({ size = 28, decorative = false }: { size?: number; decorative?: boolean }) {
  return (
    <img
      src={jtMark}
      alt={decorative ? '' : 'JobTetris'}
      height={size}
      width={Math.round(size * ASPECT)}
      style={{ display: 'block', flexShrink: 0, objectFit: 'contain' }}
    />
  );
}
